import { EMPTY_ARRAY } from 'shared/constants';

interface SearchParams {
  key: string;
  value: string;
}
interface Value {
  [key: string]: any;
}
type binarySearchFn = <T extends Value>(searchParams: SearchParams, arr?: T[]) => T | undefined;

export const binarySearch: binarySearchFn = ({ key = '', value = ''}, arr = EMPTY_ARRAY) => {
  let i = 0;
  let arrLength = arr.length;
  let k: number;

  while (i < arrLength) {
    k = Math.floor((i + arrLength) / 2);
    if (value <= arr[k][key]) arrLength = k;
    else i = k + 1;
  }

  if (arr[i] && arr[i][key] === value) return arr[i];
  return undefined;
};

export default binarySearch;
